import createReducer from 'common/redux/utils/createReducer';
import { Map } from 'immutable';
import keyBy from 'lodash.keyby';
import uid from 'uid';
import { RECEIVE_FUNNEL } from 'funnel/actions/funnel';
import * as actions from 'funnel/actions/advice';

const getInitialState = {
  items: Map(),
};

const advices = createReducer(getInitialState, {
  [RECEIVE_FUNNEL](state, { funnel }) {
    const { advices } = funnel;

    return {
      ...state,
      items: Map(keyBy(advices, 'id')),
    };
  },
  [actions.CREATE_ADVICE](state, { fields }) {
    const advice = {
      id: uid(),
      new: true,
      active: true,
      ...fields,
    };

    return {
      ...state,
      items: state.items.set(advice.id, advice),
    };
  },
  [actions.UPDATE_ADVICE](state, { id, fields }) {
    return {
      ...state,
      items: state.items.update(id.toString(), value => {
        return {
          ...value,
          ...fields,
        };
      }),
    };
  },
  [actions.TOGGLE_ADVICE](state, { advice }) {
    return {
      ...state,
      items: state.items.update(advice.toString(), value => {
        return {
          ...value,
          active: !value.active,
        };
      }),
    };
  },
  [actions.DELETE_ADVICE](state, { advice }) {
    return {
      ...state,
      items: state.items.delete(advice.id.toString()),
    };
  },
});

export default advices;



// WEBPACK FOOTER //
// ./src/modules/funnel/reducers/advices.js